if (!customElements.get('sale-countdown')) {
  customElements.define(
    'sale-countdown',
    class SaleCountdown extends HTMLElement {
      connectedCallback() {
        this.loop = this.dataset.loop === 'true';

        if (this.loop) {
          this.cycleDuration = (Number(this.dataset.loopDays) || 7) * 24 * 60 * 60 * 1000;
          // Any fixed point in the past works as the cycle anchor - it just keeps every
          // visitor's countdown in sync with the same repeating schedule, forever, with
          // no stored "next end date" to maintain.
          this.cycleAnchor = new Date('2024-01-01T00:00:00Z').getTime();
          this.targetTime = this.nextCycleTarget();
        } else {
          const endDate = new Date(this.dataset.endDate.replace(' ', 'T'));

          if (isNaN(endDate.getTime())) {
            this.closest('.trust-sale-banner__countdown-wrap')?.remove();
            return;
          }

          this.targetTime = endDate.getTime();
        }

        this.daysEl = this.querySelector('[data-days]');
        this.hoursEl = this.querySelector('[data-hours]');
        this.minutesEl = this.querySelector('[data-minutes]');
        this.secondsEl = this.querySelector('[data-seconds]');

        this.update();
        this.interval = setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      nextCycleTarget() {
        const now = Date.now();
        const elapsed = now - this.cycleAnchor;
        const cyclePosition = ((elapsed % this.cycleDuration) + this.cycleDuration) % this.cycleDuration;
        return now + (this.cycleDuration - cyclePosition);
      }

      update() {
        let diff = this.targetTime - Date.now();

        if (diff <= 0) {
          if (this.loop) {
            this.targetTime = this.nextCycleTarget();
            diff = this.targetTime - Date.now();
          } else {
            clearInterval(this.interval);
            this.closest('.trust-sale-banner__countdown-wrap')?.remove();
            return;
          }
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);

        this.daysEl.textContent = String(days).padStart(2, '0');
        this.hoursEl.textContent = String(hours).padStart(2, '0');
        this.minutesEl.textContent = String(minutes).padStart(2, '0');
        this.secondsEl.textContent = String(seconds).padStart(2, '0');
      }
    }
  );
}
